export function updateQueryString(url: string, params:{[param: string]:string}) {
    let urlObj = new URL(url);

    for (let key in params) {
        urlObj.searchParams.set(key, params[key]);
    }

    return urlObj.href;
}